/*
 * File: ChangeClientModal.tsx
 * Project: a-a
 * File Created: Wednesday, 15th October 2025 9:21:15 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 23rd October 2025 11:04:01 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import { Box, Typography } from '@mui/material';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';

const ChangeClientModal = ({
  modalOpen,
  setChangeClient,
  handleUnLink,
}: {
  modalOpen: boolean;
  setChangeClient: React.Dispatch<React.SetStateAction<boolean>>;
  handleUnLink: () => Promise<void>;
}) => {
  return (
    <CustomModal handleClose={() => setChangeClient(false)} open={modalOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '16px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,

            width: { xs: '400px' },
            // height: '183px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: { xs: '24px', xl: '32px' }, flexDirection: 'column' }}>
            <Typography variant='responsiveHeading3'>Change Connected Client?</Typography>
            <Typography variant='responsiveBody2' sx={{ color: zeplinColor.Neutral8 }}>
              You’re about to disconnect the current client and select a new one. Are you sure you
              want to proceed?
            </Typography>
            <Box
              sx={{
                display: 'flex',

                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <Box
                onClick={() => {
                  setChangeClient(false);
                }}
                sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Neutral1,
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    // width: '312px',
                    // height: '183px',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                  aria-role='button'
                >
                  <Typography variant='responsiveButtonMedium' color={zeplinColor.BasicBlack}>
                    Cancel
                  </Typography>
                </CustomCard>
              </Box>
              <Box
                onClick={() => {
                  handleUnLink();
                }}
                sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '14px 32px',
                    backgroundColor: zeplinColor.Brand1,
                    cursor: 'pointer',
                    // border: `1px solid ${zeplinColor.BasicBlack}`,
                    // width: '312px',
                    // height: '183px',
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                  aria-role='button'
                >
                  <Typography
                    variant='responsiveButtonMedium'
                    color={zeplinColor.Neutral1}
                    sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                  >
                    Yes, Change Client
                  </Typography>
                </CustomCard>
              </Box>
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default ChangeClientModal;
